import React from "react";
import { BsPersonCircle, BsGeoAltFill } from "react-icons/bs";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import secureLocalStorage from "react-secure-storage";
import "./header.css";

const HeaderUser = () => {
  const [open, setOpen] = React.useState(false);

  const logout = React.useCallback(() => {
    secureLocalStorage.clear();
    window.location.href = "/";
  }, []);

  const alterarSenha = React.useCallback(() => {
    window.location.href = "/alterar-senha";
  }, []);

  const User: any = secureLocalStorage.getItem("username");
  const Profile: any = secureLocalStorage.getItem("profile");
  const Unidade: any = secureLocalStorage.getItem("unidade");

  // fecha dropdown ao clicar fora
  const ref = React.useRef<HTMLDivElement | null>(null);
  React.useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

return (
  <div className="header-float">        
    <div className="header-card">
      <div className="unit-box" title={Unidade || ""}>
        <BsGeoAltFill size={18} color="#f1c40f" />
        <span className="unit-label">Unidade:&nbsp;</span>
        <span className="unit-name">{Unidade}</span>
      </div>

      <div className="user-area" ref={ref}>
        <button
          type="button"
          className="content-header-info"
          onClick={() => setOpen(v => !v)}
          aria-haspopup="menu"
          aria-expanded={open}
        >
          <BsPersonCircle size={20} />
          <p className="user-id" title={User}>{User}</p>
          {open ? <IoIosArrowUp size={18} /> : <IoIosArrowDown size={18} />}
        </button>

        {open && (
          <div className="content-options" role="menu">
            {Profile === "usuarioFornecedor" && (
              <button onClick={alterarSenha} role="menuitem">Alterar Senha</button>
            )}
            <button onClick={logout} role="menuitem">Sair</button>
          </div>
        )}
      </div>
    </div>
  </div>
);
};

export default HeaderUser;
